import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Footer.scss';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} className="text-center">
            <div className="footer-links">
              <Link to="/">Inicio</Link>
              <Link to="/privacy">Política de Privacidad</Link>
            </div>
            <p className="footer-label-first">
              © {new Date().getFullYear()} CodeTrend. Todos los derechos reservados.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;